import { Logger} from '../../interfaces/logger.interface';

export class BrowserLogger implements Logger 
{

    public loggerInitialized = true;
        constructor()
        {
                //super();
                this.loggerInitialized = true;
        }
        
        //log error
        public logError(source:string, message:string) {
            console.error(source + ":" + message);
        }

        //log info
        public logInfo(source:string, message:string) {
            console.log(source + ":" + message);
        }

        //log warning
        public logWarning(source:string, message:string) {
            console.warn(source + ":" + message);
        }
}